export const GET_APP_CONFIGURATION_REQUEST = 'GET_APP_CONFIGURATION_REQUEST';
export const GET_APP_CONFIGURATION_SUCCESS = 'GET_APP_CONFIGURATION_SUCCESS';
export const GET_APP_CONFIGURATION_FAILED = 'GET_APP_CONFIGURATION_FAILED';
